// extracted by mini-css-extract-plugin
export default {"container":"dG-z","innerContainer":"eG-z","multipleLines":"fG-z","heading":"gG-z","content":"hG-z","linkColor":"iG-z"};